import {
  SCORE_COMPONENT_META,
  computeNewsScoreFromComponents,
  parseScoreComponents,
} from "@/shared/utils/newsScoreConfig";

function ScoreBar({ value }) {
  const pct = Math.max(0, Math.min(100, (value / 10) * 100));
  return (
    <div className="h-1 w-full overflow-hidden rounded-full bg-gray-100 dark:bg-gray-700">
      <div
        className="h-full rounded-full bg-secondary transition-all"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}

const NewsScoreTooltipContent = ({ scoreComponents, newsScore }) => {
  if (!scoreComponents) return null;

  const scores = parseScoreComponents(scoreComponents);
  const computedScore = computeNewsScoreFromComponents(scoreComponents);
  const displayTotal =
    typeof newsScore === "number" ? newsScore.toFixed(1) : computedScore.toFixed(1);

  return (
    <div className="flex flex-col gap-2.5">
      <div>
        <p className="text-[11px] font-semibold text-gray-900 dark:text-gray-100">News score breakdown</p>
        <p className="mt-0.5 text-[10px] leading-snug text-gray-500 dark:text-gray-400">
          Weighted score = 40% Relevance + 20% Freshness + 20% Persona + 20%
          Credibility
        </p>
      </div>

      <div className="flex flex-col gap-2">
        {SCORE_COMPONENT_META.map(({ key, label, description }) => {
            const value = scores[key];

            return (
              <div key={key} className="flex flex-col gap-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-[10px] font-semibold text-gray-800 dark:text-gray-200">
                    {label}
                  </span>
                  <span className="shrink-0 text-[10px] font-medium text-gray-600 dark:text-gray-300">
                    {value}/10
                  </span>
                </div>
                <ScoreBar value={value} />
                <p className="text-[9.5px] leading-snug text-gray-600 dark:text-gray-400">
                  {description}
                </p>
              </div>
            );
          },
        )}
      </div>

      <div className="border-t border-gray-100 dark:border-gray-700 pt-2">
        <p className="text-[10px] font-semibold text-gray-800 dark:text-gray-100">
          Total score: {displayTotal}
        </p>
      </div>
    </div>
  );
};

export default NewsScoreTooltipContent;
